import WidgetLoading from '../../../../components/common/cards/widget-loading'
import { VpButton } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import StoreTrajectoryRecap from './recap/store-trajectory-recap'
import { useNavigate } from 'react-router'
import { getPathFromRouteId } from 'core/utils/route-utils'
import { RouteId } from 'core/routing/router/route-ids'
import { useContext } from 'react'
import { StoreTrajectoryContext } from '../state/store-trajectory-context'
import StoreTrajectoryValidator from '../store-trajectory-validator'

import useStoreValidatedTrajectoryValues from './use-store-trajectory-validated-values'

const StoreTrajectoryConsult = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { storeId, targetYear } = useContext(StoreTrajectoryContext)

  const goBackToEdit = () => {
    void navigate(getPathFromRouteId(RouteId.StoreTrajectoriesEdit))
  }

  const { isLoading, storeTrajectoryConsultValues } = useStoreValidatedTrajectoryValues(storeId, targetYear)

  return (
    <div className="mg-store-trajectory">
      <div className="mg-store-trajectory-header">
        <div className="mg-store-trajectory-header-title vp-title-m" data-testid="store-trajectory-consult-title">
          {t('general.trajectory.store.consult.title', { year: targetYear })}
          <StoreTrajectoryValidator
            validatorUid={storeTrajectoryConsultValues?.validation?.validatorUid}
            validationDate={storeTrajectoryConsultValues?.validation?.validationDate}
          />
        </div>
        <div className="mg-store-trajectory-header-actions" data-testid="store-trajectory-consult-actions">
          <VpButton
            data-testid="store-trajectory-consult-modify"
            variant="negative"
            variantStyle="regular"
            size="medium"
            onClick={goBackToEdit}
          >
            {t('general.trajectory.store.consult.modify')}
          </VpButton>
        </div>
      </div>
      <div className="mg-store-trajectory-body" data-testid="store-trajectory-consult-body">
        {isLoading ? (
          <WidgetLoading
            className="mg-store-trajectory-consult-loading"
            dataTestId="store-trajectory-consult-loading"
            skeletonCount={3}
          />
        ) : (
          <div className="mg-store-trajectory-body-content" data-testid="store-trajectory-consult-content">
            <StoreTrajectoryRecap storeTrajectoryConsultValues={storeTrajectoryConsultValues} />
          </div>
        )}
      </div>
    </div>
  )
}

export default StoreTrajectoryConsult
